<template>
	<div class="my-3">
		<ValidationObserver v-slot="{ invalid }" ref="observer">
			<b-form role="form">
				<b-row>
					<b-col cols="8">
						<b-form-group v-if="isForeigIncome" label="Tax Deduction">
							<b-input-group size="md" prepend="RM">
								<b-form-input v-model="tax_deduction" type="number"></b-form-input>
							</b-input-group>
						</b-form-group>

						<b-form-group v-else label="Tax Deduction">
							<b-form-input v-model="tax_deduction" type="number"></b-form-input>
						</b-form-group>
					</b-col>
				</b-row>
				<b-row v-if="isForeigIncome">
					<b-col cols="8">
						<b-form-group v-if="isForeigIncome" label="NDI Deduction">
							<b-input-group size="md" prepend="RM">
								<b-form-input v-model="ndi_deduction" type="number"></b-form-input>
							</b-input-group>
						</b-form-group>
					</b-col>
				</b-row>
				<b-row>
					<b-col cols="8">
						<b-form-group v-if="isForeigIncome" label="Other Deduction">
							<b-input-group size="md" prepend="RM">
								<b-form-input v-model="formattedTotalOtherIncome" type="text" disabled></b-form-input>
							</b-input-group>
						</b-form-group>

						<b-form-group v-else label="Other Deduction">
							<b-form-input v-model="formattedTotalOtherIncome" type="text" disabled></b-form-input>
						</b-form-group>
					</b-col>
				</b-row>

				<el-table :data="deductions" style="width: 100%" cell-class-name="px-3">
					<el-table-column label="No." width="50" align="center">
						<template slot-scope="scope">{{ scope.$index + 1 }}</template>
					</el-table-column>
					<el-table-column label="Code" width="200">
						<template slot-scope="{row}">
							<b-form-input v-model="row.code"></b-form-input>
						</template>
					</el-table-column>
					<el-table-column label="Description">
						<template slot-scope="{row}">
							<b-form-input v-model="row.description"></b-form-input>
						</template>
					</el-table-column>
					<el-table-column :label="isForeigIncome ? 'Amount' : 'Amount(RM)'">
						<template slot-scope="{row}">
							<CurrencyInput :class="isUseNewInstallment(row) ? 'd-none' : ''" v-model="row.amount"
								:options="currencyOptions" />
							<b-input-group :class="isUseNewInstallment(row) ? '' : 'd-none'">
								<template #append>
									<el-popover placement="top-start" trigger="hover">
										<p>RM {{ row.amount | moneyFormatter }} Has consolidate With New Instalment RM {{ row.new_instalment
											|
											moneyFormatter}}</p>
										<b-input-group-text slot="reference">
											<strong class="text-danger"><i class="el-icon-info"></i></strong>
										</b-input-group-text>
									</el-popover>
								</template>
								<CurrencyInput v-model="row.new_instalment" :options="currencyOptions" disabled />
							</b-input-group>
							<!-- <ValidationProvider
                                v-slot="{ errors }"
                                :rules="{ currency: true }"
                                :vid="'amount'"
                            >
                                <b-form-input v-model="row.amount"></b-form-input>
                                <small v-if="errors[0]" class="text-danger">{{ errors[0] }}</small>
                            </ValidationProvider> -->
						</template>
					</el-table-column>
					<el-table-column label="Actions">
						<template slot-scope="{row}">
							<el-button @click.prevent="removeDeduction(row)" type="danger" icon="el-icon-close" size="mini"
								circle></el-button>
						</template>
					</el-table-column>
				</el-table>
				<b-button @click="addDeduction" block variant="outline-primary" class="mt-3">+ Add</b-button>
				<!-- <b-row class="mt-4">
                    <b-col cols="4">
                        <b-button block variant="primary" @click.prevent="update()" :disabled="invalid">Save</b-button>
                    </b-col>
                </b-row> -->
			</b-form>
		</ValidationObserver>
	</div>
</template>

<script>
import { Button, Form, FormItem, Table, TableColumn, Select, Option, Popover } from 'element-ui'
import {
	notifyFunctionMixin,
	axios,
	services,
	getHeader
} from '@/assets/js/httpImports.js'
import { mapActions } from 'pinia'
import { useCustomerStore } from '@/stores/customerStore'
import { ValidationObserver, ValidationProvider } from 'vee-validate';
import CurrencyInput from '@/components/CurrencyInput'
import '@/assets/js/formValidations.js'
import { EventBus } from '@/main'

export default {
	props: ['customer', 'main_form'],
	components: {
		CurrencyInput,
		ValidationObserver,
		ValidationProvider,
		[Button.name]: Button,
		[Form.name]: Form,
		[FormItem.name]: FormItem,
		[Table.name]: Table,
		[TableColumn.name]: TableColumn,
		[Select.name]: Select,
		[Option.name]: Option,
		[Popover.name]: Popover,
	},
	mixins: [
		notifyFunctionMixin,
	],
	data() {
		return {
			tax_deduction: 0,
			ndi_deduction: 0,
			deductions: [],
			taxDeductionVal: 0,
			ndiDeductionVal: 0,
			isCurrencyConverted: false
		}
	},
	computed: {
		isForeigIncome() {
			// return false
			const wc = _gHlp.getValue(this.main_form, 'working_country');
			return !_gHlp.isEmpty(wc) && wc != 'Malaysia';
		},
		currencyRate() {
			return _gHlp.getValue(this.main_form, 'foreign_currency');
		},
		totalDeductions() {
			const total = this.deductions.reduce((acc, rental) => {
				const amount = parseFloat(rental.amount);
				const newInstallment = parseFloat(rental.new_instalment);
				if (isNaN(amount)) {
					return acc;
				}
				if (this.isUseNewInstallment(rental)) {
					return acc + newInstallment;
				} else {
					return acc + amount;
				}
			}, 0);
			return total;
		},
		formattedTotalOtherIncome: {
			get() {
				return isNaN(this.totalDeductions) ? '0.00' : this.totalDeductions.toFixed(2);
			},
			set(newValue) {
			}
		},
		isGovenment() {
			return this.customer.incomes.main.income_type_id === 3 || this.customer.incomes.main.income_type_id === 5
		},
		currencyOptions() {
			return {
				currency: 'MYR',
				currencyDisplay: this.isForeigIncome ? 'symbol' : 'hidden',
				autoDecimalDigits: true,
			};
		},
	},
	watch: {
		customer: {
			handler: function (newValue) {
				if (!_gHlp.isEmpty(newValue)) {
					this.initData();
				}
			},
			immediate: true
		},
		main_form: {
			handler: function (newValue) {
				if (!_gHlp.isEmpty(newValue)) {
					this.initData();
				}
			},
			immediate: true
		},
	},
	created() {
		EventBus.$on('collect-income-data', this.sendIncomeData);
	},
	methods: {
		...mapActions(useCustomerStore, ['getCustomer']),
		isUseNewInstallment(item) {
			return (this.isGovenment) ? (item.is_consolidate == 1) : false;
		},
		initData() {
			this.tax_deduction = _gHlp.getValue(this.customer, 'incomes.main.tax_deduction', 0);
			this.ndi_deduction = _gHlp.getValue(this.customer, 'incomes.main.ndi_deduction', 0);
			this.deductions = _gHlp.getValue(this.customer, 'incomes.other_tax_deduction', []);

			// if (!this.isForeigIncome) {
			// 	this.tax_deduction = this.taxDeductionVal;
			// 	this.ndi_deduction = this.ndiDeductionVal;
			// } else if (this.isForeigIncome  && !this.isCurrencyConverted) {
			// 	this.tax_deduction = _gHlp.currencyFromRM(this.taxDeductionVal, this.currencyRate)
			// 	this.ndi_deduction = _gHlp.currencyFromRM(this.ndiDeductionVal, this.currencyRate)
			// 	this.deductions.forEach(el => {
			// 		el.amount = _gHlp.currencyFromRM(el.amount, this.currencyRate)
			// 	});
			// 	this.isCurrencyConverted = true;
			// }
		},
		setData() {
			let deductions = this.deductions.map((obj, index) => {
				return {
					...(obj.customer_tax_deduction_id && { customer_tax_deduction_id: obj.customer_tax_deduction_id }),
					// amount: (this.isForeigIncome) ? _gHlp.currencyToRM(obj.amount, this.currencyRate) : obj.amount,
					amount: obj.amount,
					description: obj.description,
					code: obj.code,
				}
			})

			let data = {
				deductions: deductions,
				tax_deduction: this.tax_deduction,
				ndi_deduction: (this.isForeigIncome) ? this.ndi_deduction : 0,
				total_other_deduction: this.totalDeductions
			}
			// if (this.isForeigIncome) {
			// 		data = {
			// 			deductions: deductions,
			// 			tax_deduction: _gHlp.currencyToRM(this.tax_deduction, this.currencyRate),
			// 			ndi_deduction: _gHlp.currencyToRM(this.ndi_deduction, this.currencyRate),
			// 			total_other_deduction: this.totalDeductions
			// 		}
			// }

			return data
		},
		update() {
			let data = this.setData()
			axios.post(services.customer + 'customer/' + this.customer.customer_id + '/income/tax_deductions', data, { headers: getHeader() })
				.then(res => {
					this.notifySuccess('<b>Tax Deduction: ' + this.customer.name + '</b> - Successfully Updated.')
					this.getCustomer(this.customer.customer_id)
				})
				.catch(e => {
					this.errorFunction(e)
				})
		},
		removeDeduction(item) {
			if (this.deductions.length > 0) {
				var index = this.deductions.indexOf(item);
				this.deductions.splice(index, 1);
			}
		},
		addDeduction() {
			this.deductions.push({
				customer_id: this.customer.customer_id,
				amount: null,
				code: null,
				is_consolidate: 0,
				description: null
			});
		},
		sendIncomeData() {
			this.$emit('income-data-collected', this.setData());
		}
	}
}
</script>
